import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, withCtx as _withCtx, createVNode as _createVNode, vShow as _vShow, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = { class: "main_div" }
const _hoisted_2 = {
  key: 0,
  class: "loading-indicator"
}
const _hoisted_3 = { key: 1 }
const _hoisted_4 = { class: "table-container" }
const _hoisted_5 = { key: 1 }
const _hoisted_6 = {
  key: 0,
  class: "pagination-controls",
  style: {"margin-top":"15px","text-align":"center"}
}
const _hoisted_7 = { style: {"margin":"0 10px"} }
const _hoisted_8 = {
  key: 0,
  class: "organization-details-content"
}
const _hoisted_9 = { style: {"text-align":"right","margin-top":"20px"} }
const _hoisted_10 = { class: "registration-form-content" }
const _hoisted_11 = { style: {"text-align":"right","margin-top":"20px"} }
const _hoisted_12 = { style: {"text-align":"right","margin-top":"20px"} }

import { ref, onMounted, h, nextTick } from "vue";
import { getCallable } from "@/config/env";
import {
  NSpace,
  NCard,
  NDataTable,
  NButton,
  NModal,
  NDescriptions,
  NDescriptionsItem,
  NForm,
  NFormItem,
  NInput,
  NInputNumber,
  NInputGroup,
  FormInst,
  FormRules,
  NIcon,
  NSpin,
  useMessage,
  useNotification,
  useDialog,
} from "naive-ui";
import Loading from "@/components/Loading.vue";
import { useRouter } from "vue-router";
import * as common from "@/assets/common/common";
import { useAuth } from "@/composables/useAuth";
import { usePagination } from "@/composables/usePagination";
import { Product } from "@/model/product";


export default /*@__PURE__*/_defineComponent({
  __name: 'Product',
  setup(__props) {

const { loading } = useAuth(); // 전역 로딩 상태
const componentKey = ref(0); // To force re-render if needed
const getProductsCallable = getCallable("getProducts");
const updateProductCallable = getCallable("updateProduct");
const addProductCallable = getCallable("addProduct");

const message = useMessage();
const notification = useNotification();
const dialog = useDialog();

const router = useRouter();

// usePagination 적용
const {
  paginatedItems: products, // 데이터 명칭 변경
  listLoading, // usePagination의 listLoading 사용
  error, // usePagination의 error 사용
  currentPage,
  hasNextPage,
  goToNextPage: composableGoToNextPage,
  goToPreviousPage: composableGoToPreviousPage,
  refreshData: composableRefreshProducts,
} = usePagination<Product>(
  async (params) => getProductsCallable(params), // API 호출 함수 전달
  10 // 페이지 크기 (예시로 10개 설정)
);

// 전역 로딩 상태를 포함하는 래퍼 함수들
async function wrappedRefreshProducts() {
  loading.value = true;
  await composableRefreshProducts();
  loading.value = false;
}

const selectedProduct = ref<Product | null>(null);
const showRegistrationForm = ref<boolean>(false);
const showDetailsModal = ref<boolean>(false);

const registrationFormRef = ref<FormInst | null>(null);
const registrationModel = ref<Partial<Product>>({
  name: "",
  price: 0,
  type: "",
  description: "",
  template_form_id: "",
  personal_template_form_id: "",
});
const showEditModal = ref<boolean>(false);
const isRegistering = ref<boolean>(false);
const editFormRef = ref<FormInst | null>(null);
const editModel = ref<Partial<Product>>({
  SK: "",
  name: "",
  price: 0,
  type: "",
  grades: "",
  description: "",
  status: "",
  template_form_id: "",
  personal_template_form_id: "",
});
const isUpdating = ref<boolean>(false);

const registrationRules: FormRules = {
  name: [
    {
      required: true,
      message: "상품명 입력해주세요.",
      trigger: ["input", "blur"],
    },
  ],
  price: [
    { required: true, message: "가격을 입력해주세요." },
    {
      type: "number",
      message: "가격은 숫자여야 합니다.",
      trigger: ["input", "blur"],
    },
  ],
  type: [
    {
      required: true,
      message: "진단 타입(ex> putt_e)을 입력해주세요.",
      trigger: ["input", "blur"],
    },
  ],
};

const columns = [
  {
    title: "종류",
    key: "SK",
    resizable: true,
    render(row: Product) {
      if (row.SK.startsWith("personal")) {
        return "진단 검사";
      } else if (row.SK.startsWith("org")) {
        return "집단 분석";
      } else if (row.SK.startsWith("offline")) {
        return "상담코칭";
      } else if (row.SK.startsWith("activity")) {
        return "Activity";
      } else if (row.SK.startsWith("expert")) {
        return "전문가교육";
      } else {
        return "기타";
      }
    },
  },
  {
    title: "상품명",
    key: "name",
    resizable: true,
  },
  {
    title: "가격",
    key: "price",
    resizable: true,
    render(row: Product) {
      return common.formatNumberWithCommas(row.price);
    },
  },
  {
    title: "타입",
    key: "type",
    resizable: true,
  },
  {
    title: "상태",
    key: "status",
    resizable: true,
    render(row: Product) {
      if (!row.status) {
        return "판매중";
      } else {
        // TODO : 아직은 상태 값이 정해지지 않았음.
        return row.status;
      }
    },
  },
  {
    title: "상세보기",
    key: "actions",
    render(row: Product) {
      return h(
        NButton,
        {
          strong: true,
          tertiary: true,
          size: "small",
          onClick: () => displayProductDetails(row, false),
        },
        { default: () => "상세" }
      );
    },
  },
  {
    title: "정보 수정",
    key: "actions",
    render(row: Product) {
      return h(
        NButton,
        {
          strong: true,
          tertiary: true,
          size: "small",
          onClick: () => displayProductDetails(row, true),
        },
        { default: () => "수정" }
      );
    },
  },
];

async function wrappedGoToNextPage() {
  if (!hasNextPage.value) return;
  await composableGoToNextPage();
}

async function wrappedGoToPreviousPage() {
  if (currentPage.value <= 1) return;
  await composableGoToPreviousPage();
}

function goToRegisterOrganization() {
  showRegistrationForm.value = true;
  // 필요하다면 여기서 registrationModel 초기화 또는 사전 설정
}

function displayProductDetails(product: Product, isUpdate = false) {
  showRegistrationForm.value = false;
  loading.value = true;
  error.value = null;
  selectedProduct.value = product; // Type assertion
  if (isUpdate) openEditModal(product);
  else showDetailsModal.value = true;
  loading.value = false;
}

function openEditModal(product: Product) {
  // Product 객체의 복사본을 editModel에 할당하여 원본 데이터 변경 방지
  editModel.value = { ...product };
  showEditModal.value = true;
  nextTick(() => {
    editFormRef.value?.restoreValidation();
  });
}

function closeDetailsModal() {
  showDetailsModal.value = false;
}

function onDetailsModalClose() {}

function closeEditModal() {
  showEditModal.value = false;
}

function onEditModalClose() {
  editModel.value = {
    // 폼 모델 초기화
    SK: "",
    name: "",
    price: 0,
    type: "",
    grades: "",
    description: "",
    status: "",
    template_form_id: "",
    personal_template_form_id: "",
  };
  isUpdating.value = false;
}

function onRegistrationModalClose() {
  registrationModel.value = {
    name: "",
    price: 0,
    type: "",
    description: "",
    template_form_id: "",
    personal_template_form_id: "",
  };
  isRegistering.value = false;
  registrationFormRef.value?.restoreValidation();
}

async function handleUpdateSubmit() {
  try {
    await editFormRef.value?.validate();
  } catch (errors) {
    message.error("입력 내용을 확인해주세요.");
    return;
  }

  if (!editModel.value.SK) {
    message.error("수정할 상품 정보가 올바르지 않습니다.");
    return;
  }
  isUpdating.value = true;
  try {
    const payload = { ...editModel.value };
    const result = await updateProductCallable(payload);

    if (common.evalFunctionResult(result)) {
      message.success("상품 정보가 성공적으로 수정되었습니다.");
      closeEditModal();
      await wrappedRefreshProducts(); // 목록 새로고침
    } else {
      notification.error({
        title: "수정 실패",
        description: `상품 정보 수정 중 오류 발생: ${
          common.getResultError(result) || "알 수 없는 오류"
        }`,
        duration: 3000,
      });
    }
  } catch (err: any) {
    console.error("상품 수정 API 호출 실패:", err);
    notification.error({
      title: "수정 실패",
      description: `상품 정보 수정 중 심각한 오류 발생: ${
        err.message || "서버 통신 오류"
      }`,
      duration: 3000,
    });
  } finally {
    isUpdating.value = false;
  }
}

async function handleRegistrationSubmit() {
  try {
    await registrationFormRef.value?.validate();
  } catch (errors) {
    message.error("입력 내용을 확인해주세요.");
    return;
  }

  isRegistering.value = true;
  try {
    const payload: Partial<Product> = {
      ...registrationModel.value,
      price: Number(registrationModel.value.price), // 확실히 숫자로 전달
    };
    const result = await addProductCallable(payload);

    if (common.evalFunctionResult(result)) {
      message.success("상품이 성공적으로 등록되었습니다.");
      showRegistrationForm.value = false; // 모달 닫기
      await wrappedRefreshProducts(); // 목록 새로고침
    } else {
      notification.error({
        title: "등록 실패",
        content: `상품 등록 중 오류 발생: ${
          common.getResultError(result) || "알 수 없는 오류"
        }`,
        duration: 3000,
      });
    }
  } catch (err: any) {
    console.error("상품 등록 API 호출 실패:", err);
    notification.error({
      title: "등록 실패",
      content: `상품 등록 중 심각한 오류 발생: ${
        err.message || "서버 통신 오류"
      }`,
      duration: 3000,
    });
  } finally {
    isRegistering.value = false;
  }
}

onMounted(async () => {
  wrappedRefreshProducts();
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_openBlock(), _createElementBlock("div", {
      style: {"height":"auto"},
      key: componentKey.value
    }, [
      _createVNode(_unref(NSpace), null, {
        default: _withCtx(() => [
          _createVNode(_unref(NCard), { style: {"margin-top":"20px","margin-left":"80px","border":"0px","min-width":"800px"} }, {
            default: _withCtx(() => [
              _createVNode(_unref(NSpace), {
                "item-style": "display: flex;",
                align: "center"
              }, {
                default: _withCtx(() => _cache[17] || (_cache[17] = [
                  _createElementVNode("div", { style: {"font-size":"20px","width":"200px","font-weight":"bold"} }, " 기관용 상품 관리 ", -1)
                ])),
                _: 1
              }),
              _cache[20] || (_cache[20] = _createElementVNode("div", { class: "content_delimiter_line" }, null, -1)),
              _withDirectives(_createVNode(Loading, null, null, 512), [
                [_vShow, _unref(loading)]
              ]),
              _createElementVNode("div", null, [
                _createElementVNode("button", {
                  onClick: goToRegisterOrganization,
                  class: "action-button"
                }, " 신규 상품 등록 "),
                (_unref(listLoading))
                  ? (_openBlock(), _createElementBlock("div", _hoisted_2, " 상품 목록을 불러오는 중... "))
                  : _createCommentVNode("", true),
                (!_unref(listLoading) && !_unref(error))
                  ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                      _createElementVNode("div", _hoisted_4, [
                        (_unref(products).length > 0)
                          ? (_openBlock(), _createBlock(_unref(NDataTable), {
                              key: 0,
                              columns: columns,
                              data: _unref(products),
                              pagination: false,
                              bordered: true
                            }, null, 8, ["data"]))
                          : (_openBlock(), _createElementBlock("p", _hoisted_5, "등록된 상품이 없습니다."))
                      ]),
                      (_unref(products).length > 0)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                            _createVNode(_unref(NButton), {
                              onClick: wrappedGoToPreviousPage,
                              disabled: _unref(currentPage) === 1,
                              style: {"margin-right":"8px"}
                            }, {
                              default: _withCtx(() => _cache[18] || (_cache[18] = [
                                _createTextVNode(" 이전 페이지 ")
                              ])),
                              _: 1
                            }, 8, ["disabled"]),
                            _createElementVNode("span", _hoisted_7, _toDisplayString(_unref(currentPage)) + " 페이지", 1),
                            _createVNode(_unref(NButton), {
                              onClick: wrappedGoToNextPage,
                              disabled: !_unref(hasNextPage)
                            }, {
                              default: _withCtx(() => _cache[19] || (_cache[19] = [
                                _createTextVNode(" 다음 페이지 ")
                              ])),
                              _: 1
                            }, 8, ["disabled"])
                          ]))
                        : _createCommentVNode("", true)
                    ]))
                  : _createCommentVNode("", true)
              ])
            ]),
            _: 1
          }),
          _createVNode(_unref(NModal), {
            show: showDetailsModal.value,
            "onUpdate:show": _cache[0] || (_cache[0] = ($event: any) => ((showDetailsModal).value = $event)),
            preset: "card",
            style: {"width":"600px"},
            title: "진단 상품 상세 정보",
            onAfterLeave: onDetailsModalClose
          }, {
            default: _withCtx(() => [
              (selectedProduct.value)
                ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                    _createVNode(_unref(NDescriptions), {
                      "label-placement": "left",
                      bordered: "",
                      column: 1,
                      size: "small"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_unref(NDescriptionsItem), { label: "ID" }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(selectedProduct.value.SK), 1)
                          ]),
                          _: 1
                        }),
                        _createVNode(_unref(NDescriptionsItem), { label: "상품명" }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(selectedProduct.value.name), 1)
                          ]),
                          _: 1
                        }),
                        _createVNode(_unref(NDescriptionsItem), { label: "가격" }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(common.formatNumberWithCommas(selectedProduct.value.price)), 1)
                          ]),
                          _: 1
                        }),
                        _createVNode(_unref(NDescriptionsItem), { label: "타입" }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(selectedProduct.value.type), 1)
                          ]),
                          _: 1
                        }),
                        _createVNode(_unref(NDescriptionsItem), { label: "설명" }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(selectedProduct.value.description || "N/A"), 1)
                          ]),
                          _: 1
                        }),
                        _createVNode(_unref(NDescriptionsItem), { label: "기관용 템플릿 폼 ID" }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(selectedProduct.value.template_form_id || "N/A"), 1)
                          ]),
                          _: 1
                        }),
                        _createVNode(_unref(NDescriptionsItem), { label: "개인용 템플릿 폼 ID" }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(selectedProduct.value.personal_template_form_id || "N/A"), 1)
                          ]),
                          _: 1
                        }),
                        _createVNode(_unref(NDescriptionsItem), { label: "상태" }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(selectedProduct.value.status ? selectedProduct.value.status : "판매중"), 1)
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }),
                    _createElementVNode("div", _hoisted_9, [
                      _createVNode(_unref(NButton), {
                        onClick: closeDetailsModal,
                        type: "primary"
                      }, {
                        default: _withCtx(() => _cache[21] || (_cache[21] = [
                          _createTextVNode("닫기")
                        ])),
                        _: 1
                      })
                    ])
                  ]))
                : _createCommentVNode("", true)
            ]),
            _: 1
          }, 8, ["show"]),
          _createVNode(_unref(NModal), {
            show: showRegistrationForm.value,
            "onUpdate:show": _cache[8] || (_cache[8] = ($event: any) => ((showRegistrationForm).value = $event)),
            preset: "card",
            style: {"width":"600px"},
            title: "신규 상품 등록",
            onAfterLeave: onRegistrationModalClose
          }, {
            default: _withCtx(() => [
              _createVNode(_unref(NForm), {
                ref_key: "registrationFormRef",
                ref: registrationFormRef,
                model: registrationModel.value,
                rules: registrationRules,
                "label-placement": "left",
                "label-width": "auto",
                "require-mark-placement": "right-hanging"
              }, {
                default: _withCtx(() => [
                  _createVNode(_unref(NFormItem), {
                    label: "상품명",
                    path: "name"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_unref(NInput), {
                        value: registrationModel.value.name,
                        "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((registrationModel.value.name) = $event)),
                        placeholder: "상품명"
                      }, null, 8, ["value"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_unref(NFormItem), {
                    label: "가격",
                    path: "price"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_unref(NInputNumber), {
                        value: registrationModel.value.price,
                        "onUpdate:value": _cache[2] || (_cache[2] = ($event: any) => ((registrationModel.value.price) = $event)),
                        placeholder: "가격",
                        style: {"width":"100%"},
                        min: 0
                      }, null, 8, ["value"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_unref(NFormItem), {
                    label: "타입",
                    path: "type"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_unref(NInput), {
                        value: registrationModel.value.type,
                        "onUpdate:value": _cache[3] || (_cache[3] = ($event: any) => ((registrationModel.value.type) = $event)),
                        placeholder: "타입 (예: putt_e)"
                      }, null, 8, ["value"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_unref(NFormItem), {
                    label: "기관용 템플릿 폼 ID",
                    path: "template_form_id"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_unref(NInput), {
                        value: registrationModel.value.template_form_id,
                        "onUpdate:value": _cache[4] || (_cache[4] = ($event: any) => ((registrationModel.value.template_form_id) = $event)),
                        placeholder: "기관용 템플릿 폼 ID"
                      }, null, 8, ["value"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_unref(NFormItem), {
                    label: "개인용 템플릿 폼 ID",
                    path: "personal_template_form_id"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_unref(NInput), {
                        value: registrationModel.value.personal_template_form_id,
                        "onUpdate:value": _cache[5] || (_cache[5] = ($event: any) => ((registrationModel.value.personal_template_form_id) = $event)),
                        placeholder: "개인용 템플릿 폼 ID"
                      }, null, 8, ["value"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_unref(NFormItem), {
                    label: "설명",
                    path: "description"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_unref(NInput), {
                        value: registrationModel.value.description,
                        "onUpdate:value": _cache[6] || (_cache[6] = ($event: any) => ((registrationModel.value.description) = $event)),
                        type: "textarea",
                        placeholder: "진단에 대한 간략한 설명"
                      }, null, 8, ["value"])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }, 8, ["model"]),
              _createElementVNode("div", _hoisted_10, [
                _createElementVNode("div", _hoisted_11, [
                  _createVNode(_unref(NButton), {
                    onClick: _cache[7] || (_cache[7] = ($event: any) => (showRegistrationForm.value = false)),
                    type: "tertiary",
                    style: {"margin-right":"10px"}
                  }, {
                    default: _withCtx(() => _cache[22] || (_cache[22] = [
                      _createTextVNode("취소")
                    ])),
                    _: 1
                  }),
                  _createVNode(_unref(NButton), {
                    type: "primary",
                    onClick: handleRegistrationSubmit,
                    loading: isRegistering.value
                  }, {
                    default: _withCtx(() => _cache[23] || (_cache[23] = [
                      _createTextVNode("등록")
                    ])),
                    _: 1
                  }, 8, ["loading"])
                ])
              ])
            ]),
            _: 1
          }, 8, ["show"]),
          _createVNode(_unref(NModal), {
            show: showEditModal.value,
            "onUpdate:show": _cache[16] || (_cache[16] = ($event: any) => ((showEditModal).value = $event)),
            preset: "card",
            style: {"width":"600px"},
            title: "상품 정보 수정",
            onAfterLeave: onEditModalClose
          }, {
            default: _withCtx(() => [
              _createVNode(_unref(NForm), {
                ref_key: "editFormRef",
                ref: editFormRef,
                model: editModel.value,
                rules: _ctx.editRules,
                "label-placement": "left",
                "label-width": "auto",
                "require-mark-placement": "right-hanging"
              }, {
                default: _withCtx(() => [
                  _createVNode(_unref(NFormItem), {
                    label: "상품 ID",
                    path: "prod_id"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_unref(NInput), {
                        value: editModel.value.SK,
                        "onUpdate:value": _cache[9] || (_cache[9] = ($event: any) => ((editModel.value.SK) = $event)),
                        disabled: ""
                      }, null, 8, ["value"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_unref(NFormItem), {
                    label: "상품명",
                    path: "name"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_unref(NInput), {
                        value: editModel.value.name,
                        "onUpdate:value": _cache[10] || (_cache[10] = ($event: any) => ((editModel.value.name) = $event)),
                        placeholder: "진단 이름"
                      }, null, 8, ["value"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_unref(NFormItem), {
                    label: "가격",
                    path: "price"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_unref(NInputNumber), {
                        value: editModel.value.price,
                        "onUpdate:value": _cache[11] || (_cache[11] = ($event: any) => ((editModel.value.price) = $event)),
                        placeholder: "가격",
                        style: {"width":"100%"},
                        min: 0
                      }, null, 8, ["value"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_unref(NFormItem), {
                    label: "타입",
                    path: "type"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_unref(NInput), {
                        value: editModel.value.type,
                        "onUpdate:value": _cache[12] || (_cache[12] = ($event: any) => ((editModel.value.type) = $event)),
                        placeholder: "타입 (예: putt_e)"
                      }, null, 8, ["value"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_unref(NFormItem), {
                    label: "기관용 템플릿 폼 ID",
                    path: "template_form_id"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_unref(NInput), {
                        value: editModel.value.template_form_id,
                        "onUpdate:value": _cache[13] || (_cache[13] = ($event: any) => ((editModel.value.template_form_id) = $event)),
                        placeholder: "기관용 템플릿 폼 ID"
                      }, null, 8, ["value"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_unref(NFormItem), {
                    label: "개인용 템플릿 폼 ID",
                    path: "personal_template_form_id"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_unref(NInput), {
                        value: editModel.value.personal_template_form_id,
                        "onUpdate:value": _cache[14] || (_cache[14] = ($event: any) => ((editModel.value.personal_template_form_id) = $event)),
                        placeholder: "개인용 템플릿 폼 ID"
                      }, null, 8, ["value"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_unref(NFormItem), {
                    label: "설명",
                    path: "description"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_unref(NInput), {
                        value: editModel.value.description,
                        "onUpdate:value": _cache[15] || (_cache[15] = ($event: any) => ((editModel.value.description) = $event)),
                        type: "textarea",
                        placeholder: "진단에 대한 간략한 설명"
                      }, null, 8, ["value"])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }, 8, ["model", "rules"]),
              _createElementVNode("div", _hoisted_12, [
                _createVNode(_unref(NButton), {
                  onClick: closeEditModal,
                  type: "tertiary",
                  style: {"margin-right":"10px"}
                }, {
                  default: _withCtx(() => _cache[24] || (_cache[24] = [
                    _createTextVNode("취소")
                  ])),
                  _: 1
                }),
                _createVNode(_unref(NButton), {
                  type: "primary",
                  onClick: handleUpdateSubmit,
                  loading: isUpdating.value
                }, {
                  default: _withCtx(() => _cache[25] || (_cache[25] = [
                    _createTextVNode("확인")
                  ])),
                  _: 1
                }, 8, ["loading"])
              ])
            ]),
            _: 1
          }, 8, ["show"])
        ]),
        _: 1
      })
    ]))
  ]))
}
}

})